
import { ApiConfig } from '../../Config';
import axios from 'axios';

var VerifyOtpOldCellNumCtrl = function (fn, er, otp, token, ids) {

        var config = {
            headers: {
            'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
            }

        };
        var data = {
            otp: otp,
            user: sessionStorage.getItem('user')
        };


        axios
            .post(ApiConfig.url.VALIDATE_OTP_OLD_TEL, data, config)
            .then(function (result) {
                fn(result.data, result.status)
            })
            .catch(function (error) {
                er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500,
                   error !== undefined && error.response !== undefined && error.response.data !== undefined && error.response.data.details !== undefined ? error.response.data.details[0] : '5709')
            });


    }

export {
    VerifyOtpOldCellNumCtrl
};